
import React, { useState, useEffect } from 'react';

import {getBackendURL} from './utils';

// --- Admin PTC State View ---
function AdminPTCStateView() {
    const [state, setState] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
  
    React.useEffect(() => {
      fetch(getBackendURL() + '/admin/ptc_state', {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('ptc_access_token') || ''}`
        }
      })
        .then(res => {
          console.log('Response status:', res.status);
          if (!res.ok) throw new Error('Failed to fetch');
          return res.json();
        })
        .then(data => {
          setState(data);
          setLoading(false);
        })
        .catch(e => {
          setError(e.message);
          setLoading(false);
        });
    }, []);
  
    if (loading) return <div>Loading PTC State...</div>;
    if (error) return <div>Error: {error}</div>;
    return (
      <div style={{padding: 20}}>
        <h2>Admin PTC State</h2>
        <pre style={{maxWidth: 900, overflow: 'auto', background: '#eee', padding: 12, borderRadius: 8}}>
          {JSON.stringify(state, null, 2)}
        </pre>
      </div>
    );
}

export default AdminPTCStateView;